/*
 * @创建文件时间: 2019-10-30 09:58:08
 * @Auther: lfq
 * @最后修改人: lfq
 * @最后修改时间: 2019-12-10 15:53:29
 * @联系Qq:1638245306
 * @文件介绍: 
 */
/**
 * 全局提示 操作成功
 */
export const sucess = function() {
    this.$message({
        showClose: true,
        message: '操作成功',
        type: 'success'
    });
}

/**
 * 全局提示 操作失败
 */
export const error = function() {
    this.$message({
        showClose: true,
        message: '操作失败',
        type: 'error'
    });
}

/**
 * 全局确认框
 * @param {string} messages 
 */
export const msgConfirm = function(messages) {
    return new Promise((resolve, reject) => {
        this.$confirm('此操作将' + messages + ', 是否继续?', '提示', {
            showClose: false,
            closeOnClickModal: false,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            resolve()
        })
    }).catch(() => {
        this.$message({
            type: 'info',
            message: '已取消'
        });
        reject()
    })
}